// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AMh0e","box":"styles_box__BQi8K","basePopup":"styles_basePopup__BiQui"};